
  var _styles = {
  "headImgContainer": {
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem"
  },
  "couponContainer": {
    "width": "100%",
    "height": "auto",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem"
  },
  "timePeriodBar": {
    "position": "relative",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "1.01333rem",
    "borderRadius": "0.32rem 0.32rem 0 0",
    "zIndex": 1,
    "overflow": "hidden"
  },
  "timePeriodScrollView": {
    "width": "9.36rem"
  },
  "timePeriodItemBox": {
    "height": "1.01333rem",
    "display": "flex",
    "alignItems": "center",
    "position": "relative",
    "borderTopLeftRadius": "0.32rem",
    "borderTopRightRadius": "0.32rem"
  },
  "timePeriodItemBeforeAfter": {
    "width": "100%",
    "height": "100%",
    "position": "absolute",
    "zIndex": 1
  },
  "timePeriodItemContainer": {
    "position": "absolute",
    "left": "5%",
    "top": "0.13333rem",
    "width": "90%",
    "height": "0.50667rem",
    "display": "flex",
    "flexWrap": "nowrap",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "zIndex": 4,
    "borderRadius": "0.18667rem"
  },
  "timePeriodItemContainerTime": {
    "display": "flex",
    "alignItems": "center",
    "marginRight": "0.05333rem",
    "color": "rgba(255,255,255,0.8)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.37333rem",
    "height": "0.50667rem",
    "lineHeight": "0.50667rem"
  },
  "timePeriodItemContainerTips": {
    "display": "flex",
    "alignItems": "center",
    "color": "rgba(255,255,255,0.8)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "height": "0.50667rem",
    "lineHeight": "0.50667rem"
  },
  "timePeriodItemSplicingBoxLeft": {
    "position": "absolute",
    "bottom": "-0.12667rem",
    "left": "-0.38933rem",
    "width": "0.74667rem",
    "height": "0.74667rem",
    "overflow": "hidden",
    "zIndex": 2
  },
  "timePeriodItemSplicingBoxRight": {
    "position": "absolute",
    "bottom": "-0.12667rem",
    "right": "-0.38667rem",
    "width": "0.74667rem",
    "height": "0.74667rem",
    "overflow": "hidden",
    "zIndex": 2
  },
  "cutttingCircle1": {
    "position": "absolute",
    "top": "-0.38667rem",
    "left": "-0.38667rem",
    "width": "0.77333rem",
    "height": "0.77333rem",
    "borderRadius": "0.38667rem"
  },
  "cutttingCircle2": {
    "position": "absolute",
    "top": "-0.38667rem",
    "right": "-0.38667rem",
    "width": "0.77333rem",
    "height": "0.77333rem",
    "borderRadius": "0.38667rem"
  },
  "replenishCircle1": {
    "position": "absolute",
    "bottom": "-0.4rem",
    "left": "-0.64rem",
    "width": "0.64rem",
    "height": "0.64rem",
    "borderRadius": "0.32rem",
    "zIndex": 2
  },
  "replenishCircle2": {
    "position": "absolute",
    "bottom": "-0.4rem",
    "right": "-0.64rem",
    "width": "0.64rem",
    "height": "0.64rem",
    "borderRadius": "0.32rem",
    "zIndex": 2
  },
  "timePeriodItemIntervalMask1": {
    "position": "absolute",
    "bottom": "-0.12667rem",
    "left": "-0.18667rem",
    "width": "0.37333rem",
    "height": "0.74667rem",
    "zIndex": 5
  },
  "timePeriodItemIntervalMask2": {
    "position": "absolute",
    "bottom": "0.10667rem",
    "left": "-0.37333rem",
    "width": "0.74667rem",
    "height": "0.37333rem",
    "zIndex": 5
  },
  "timePeriodClaimedHeader": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "height": "0.77333rem",
    "lineHeight": "0.48rem"
  },
  "timePeriodClaimedHeaderLeft": {
    "flex": 1
  },
  "timePeriodClaimedHeaderLeftText": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.42667rem"
  },
  "timePeriodClaimedHeaderRight": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-end",
    "width": "2.13333rem"
  },
  "timePeriodClaimedHeaderRightText": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "textAlign": "right"
  },
  "couponBg": {
    "borderRadius": "0.32rem",
    "overflow": "hidden",
    "position": "relative",
    "zIndex": 2
  },
  "couponItemContainer": {
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.24rem",
    "marginRight": "0.08rem",
    "marginBottom": "0.24rem",
    "marginLeft": "0.24rem"
  },
  "allBtnContainer": {
    "position": "absolute"
  },
  "allBtnBg": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "center"
  },
  "allBtn": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "allBtnContent": {
    "width": "100%",
    "height": "100%"
  },
  "allBtnText": {
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem"
  },
  "allBtnTextNum": {
    "marginLeft": "0.05333rem",
    "marginRight": "0.05333rem",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "500",
    "fontSize": "0.42667rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/tex-external-advertising/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  